export const betStatus = {
  lose: 0,
  completed: 1,
  pending: 7
}